/* eslint-disable warp-drive/no-legacy-request-patterns */
import { service } from '@ember/service';
import Route from '@ember/routing/route';

import EnrolmentStatus from 'linced-app/enums/enrolment-status';
import PersonType from '@linc-technologies/linced-common/enums/person-type';
import { hash } from '@linc-technologies/linced-common/utils/promise';
import moment from 'moment';

export default class MedicalRoomRoute extends Route {
  // Services
  @service
  store;

  model() {
    let year = moment().year();
    let statuses = JSON.stringify([
      EnrolmentStatus.CURRENT,
      EnrolmentStatus.PENDING,
    ]);
    return hash({
      learners: this.store.query('person', {
        type: PersonType.LEARNER,
        statuses,
      }),
      medicalContacts: this.store.query('person', {
        type: PersonType.DOCTORS_AND_SPECIALISTS,
      }),
      medications: this.store.findAll('medical/medication'),
      groups: this.store.query('group', {
        year: year,
      }),
    });
  }

  resetController(controller) {
    controller.setProperties({
      groupFilter: [],
      yearLevelFilter: [],
      riskFilter: [],
      selected: [],
      fullNameFilter: '',
      planFilter: '',
    });
  }
}
